/* eslint-disable no-param-reassign, no-unused-vars */
export default {
  SET_DAMAGEPOPUP(state, payload) {
    state.showDamagePopup = payload
  },
}
